import { IconButton, List, ListItemText, TextField } from "@mui/material";
import { URow } from "../common/ui.page";
import { Cancel } from "@mui/icons-material";
import { useFilter } from "../common/filter";
import { UListItemButton } from "../common/ui.buttons";
import { useSearch } from "../common/search";
import { USkeletonList } from "../common/ui.skeletons";

export function TextFilterWithClear(props) {
    const { title } = props;

    const filter = useFilter()

    return <URow>
        <TextField
            fullWidth
            sx={{ marginY: 4 }}
            onChange={(e) => filter.setFilter(e.target.value)}
            size="small"
            label={title}
            value={filter.filter}
            variant="outlined"
            {...props} />
        <IconButton onClick={filter.clear}>
            <Cancel />
        </IconButton>
    </URow>
}